import React from 'react';
import { empty, isValidPostcode } from '../../../../Shared/Assets/utils';
import DealerInfoBlock from './dealer-info-block';
import EventBus,{ EventName } from '../../../../Shared/Assets/event-bus';

export default class DealerInfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.onSelected = this.onSelected.bind(this);
    this.fetchDealers = this.fetchDealers.bind(this);
    this.eventBus = new EventBus();

    this.state = {
      dealers: null,
      selectedDealers: [],
      isLoaded: false,
    };
  }

  fetchDealers(postcode) {
    if (!postcode || !isValidPostcode(postcode)) {
      return;
    }
    this.setState({
      dealers: null
    }, () => {
      if (!this.props.dealerApiUrl) {
        this.setState({
          dealers: []
        });
        this.props.toggleEnquiryForm(true);
        return;
      }
      fetch(this.props.dealerApiUrl + "?postcode=" + postcode)
        .then(res => res.json())
        .then(result => {

          this.setState({
            dealers: result,
            selectedDealers: []
          });

          if (result && result.length > 0) {
            // require user to select a dealer to continue
            this.props.toggleEnquiryForm(false);
          }
          else {
            this.props.toggleEnquiryForm(true);
          }

          // hide error message if any
          this.eventBus.dispatch(EventName.GenericEnquiryFormError, false);
        }, error => {
          // we allow the lead to sent through if api failed or postcode invalid
          this.setState({
            dealers: [],
            selectedDealers: []
          })
          this.props.toggleEnquiryForm(true);
        });
    });
  }

  componentDidMount() {
    this.fetchDealers(this.props.postcode);
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.postcode == this.props.postcode)
      return;
    this.fetchDealers(this.props.postcode);
  }

  onSelected(selectedDealer, isSelect) {
    if (isSelect) {
      let selectedDealers = this.state.selectedDealers;
      selectedDealers.push(selectedDealer);

      this.setState({
        selectedDealers: selectedDealers
      });

      this.props.toggleEnquiryForm(true);
    }
    else {
      let selectedDealers = this.state.selectedDealers.filter(dealer => dealer.id != selectedDealer.id);
      this.setState({
        selectedDealers: selectedDealers
      });

      if (selectedDealers.length == 0) {
        this.props.toggleEnquiryForm(false);
      }
    }
  }

  render() {
    if (empty(this.props.postcode)
      || !isValidPostcode(this.props.postcode)
      || this.state.dealers == null) {
      return "";
    }

    let header = this.state.dealers.length > 0 
      ? <h5>Please select from dealers below</h5>
      : null;

    let dealerInfoBlocks = <div className="dealer-info-block-wrapper">{this.state.dealers.map(dealer => <DealerInfoBlock key={dealer.id} data={dealer} placement={this.props.placement} onSelected={this.onSelected} />)}</div>;
    let dealerSelectionInfo = this.state.selectedDealers.length == 0 
      ? <div className="dealer-selected-info">Please select a dealer to continue</div>
      : <div className="dealer-selected-info">Your contact details for : <b>{this.state.selectedDealers.length} {this.state.selectedDealers.length===1?"Dealer":"Dealers"}</b></div>;

    return (
      <div className="dealer-selection-section">
        {header}
        {dealerInfoBlocks}
        {this.state.dealers.length > 0  && dealerSelectionInfo}
        {this.state.selectedDealers.map(dealer => <input type="hidden" key={dealer.id} name="SelectedDealers" value={dealer.id} />)}
      </div>
    );
  }
}